import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import Body from '../Body'
import UserListScreen from './UserListScreen'

// { history }
const Users = () =>
  <Body>
    <Switch>
      {/* <Route
        strict
        path="/users/create/"
        render={() =>
          <CreateUnit onCreate={unitId => history.push(`/units/${unitId}/`)} />}
      />
      <Route
        strict
        // Match only mongo id
        path="/units/:unitId([a-f0-9]{24})/"
        component={ManageUnit}
      /> */}
      <Route component={UserListScreen} />
    </Switch>
  </Body>

export default withRouter(Users)



// WEBPACK FOOTER //
// ./src/Users/index.js